
if ($('.image_displacement').length > 0) {

    $('.image_displacement').each(function () {

        let my_element = $(this);
        let my_element_id = my_element.attr('id');
        let my_image = my_element.attr("data-image");

        var app = new PIXI.Application({
            view: document.getElementById(my_element_id),
            transparent: true
        });

        var loader = new PIXI.loaders.Loader()
            .add("moist", displacement_location)
            .add("laundry", my_image)
            .load(init);

        function init(loader, resources) {

            var container = new PIXI.Container();
            var background = new PIXI.Sprite(resources.laundry.texture);

            var displacementSprite = new PIXI.Sprite(resources.moist.texture);
            var displacementFilter = new PIXI.filters.DisplacementFilter(displacementSprite);

            var wW = my_element.width();
            var wH = my_element.height();

            background.width = wW;
            background.height = wH;

            container.filterArea = new PIXI.Rectangle(0, 0, wW, wH);
            container.filters = [displacementFilter];
            displacementSprite.texture.baseTexture.wrapMode = PIXI.WRAP_MODES.REPEAT;

            window.onresize = function () {
                wW = my_element.width();
                wH = my_element.height();

                background.width = wW;
                background.height = wH;

                container.filterArea.width = wW;
                container.filterArea.height = wH;

            }

            container.addChild(background);
            container.addChild(displacementSprite);
            app.stage.addChild(container);

            var x_value = wW / 38;

            gsap.fromTo(displacementSprite, { x: -wW }, { x: 0, duration: 240,repeat: -1, ease: "linear" } );

        }

        window.addEventListener('resize', resize);

        function resize() {
            app.renderer.resize(my_element.width(), my_element.height());
        }

        resize();
    });
}